// Komponenten <eui-meddelandedialog>:

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-meddelandedialog',

	//		v-if="dialogConfig.visas"
	// .sync nedan gör att denna komponent lyssnar på eventet 'update:vpVisaDialogrutan' och då ändrar värdet på appens visaDialogrutan:
	//		<div v-html="vpMeddelandeTextEllerHtml" style="padding-bottom: .5rem;"></div>
	template: `
		<eui-dialog
			:vp-dialog-id="vpDialogId"
			:vp-bredd-med-enhet="vpBreddMedEnhet"
			:vp-dialog-config="dialogConfig"
			:vp-visa-dialogen.sync="dialogConfig.visas"
			:vp-dialog-stack="vpDialogStack"
			:vp-ikon="vpIkon"
			:vp-ikon-css-modifier-class="vpIkonCssModifierClass"
			:vp-fot-text="vpFotText"
			@knapp-tryckt-i-dialog="onKnappTrycktIDialog"
			@dialogen-inaktiverad="onMeddelandetInaktiverat"
			@dialogen-stangs="onMeddelandetStangs"
		>
			<slot>
				<div v-html="vpMeddelandeTextEllerHtml"></div>
			</slot>
		</eui-dialog>
	`,

	components: {
		euiDialog,
	},

	props: {
		vpDialogId: {
			type: String,
			default: null,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpDialogStack':
		vpDialogStack: {
			type: Array,
			required: true,
		},

		vpIkon: {	// null/undefined = saknas
			type: String,
			default: null,
		},
		vpIkonCssModifierClass: {
			type: String,
			default: null
		},

		vpMeddelandeTextEllerHtml: {
			type: [String, HTMLElement],
			default: null
		},

		vpFotText: {
			type: String,		// Får innehålla viss inline html.
			default: '&nbsp;'
		},

		vpKnappar: {
			default() {
					return [
					new euiDialogClasses.knappAvbryt({ text: 'OK', cssModifierClass: '-primar' }),
				];
			}
		},

		vpBreddMedEnhet: {
			type: String,
			default: '36rem'
		},

		//// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpVisaDialogen':
		//vpVisaMeddelandet: {
		//	type: Boolean,
		//	default: true
		//},
	},

	data() {
		return {
			uniktId: 'eui-meddelandedialog-unikt-' + (++uniktIdCounter),

			dialogConfig: new euiDialogClasses.dialogConfig(this.vpKnappar),
		};
	},

	//watch: {
	//},

	methods: {

		onKnappTrycktIDialog({ eventId, eventData })
		{
			// Stäng meddelandet direkt, alltid:
			this.dialogConfig.visas = false;

			// Obs! $root nedan!
			this.$root.$emit('knapp-tryckt-i-meddelandedialog',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);
		},

		onMeddelandetInaktiverat() {
			// Obs! $root nedan!
			this.$root.$emit('meddelandedialog-inaktiverad');
		},

		onMeddelandetStangs(dialogId) {

			// Obs! Enda anledningen till att vi skickar två olika event: Jag lyckades *inte* göra två $on-bindningar till samma event, en handler i mixin ssoAllaSidorMixin och en i sidan ordinarie app-kod. Nu emittar jag istället 2 st för att hantera dessa fall, men bara om meddelandet har ett dialogId:
			// Ett alt hade kunnat vara att bara emitta en 'meddelandedialog-stangs-for-hantering-i-mixin' här, som sedan alltid hanteras i mixinen som gör sin egen handling + i sin tur emittar en 'meddelandedialog-stangs' som hanteras i app-koden. En fördel med den approachen är att mixin bara emittar om själva hanteringen i mixinen inte övertrumfar (t.ex. ladda om sidan).
			// Todo: Låter bra även om detta blir en oren och osnygg design! Kör på den for know...

			// Obs! $root nedan!
			this.$root.$emit('meddelandedialog-stangs-for-hantering-i-mixin', dialogId);
		},
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.

		this.$nextTick(() => {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			this.dialogConfig.visas = true;
		});
	},
};
